package com.htmlagent.site.components.sections.landing

import androidx.compose.runtime.Composable
import com.htmlagent.site.KOFI_URL
import com.htmlagent.site.components.widgets.reveal
import com.htmlagent.site.i18n.LocalStrings
import com.htmlagent.site.theme.EyebrowStyle
import com.htmlagent.site.theme.TipAmountStyle
import com.htmlagent.site.theme.TipBandStyle
import com.htmlagent.site.theme.TipBodyStyle
import com.htmlagent.site.theme.TipLinkStyle
import com.htmlagent.site.theme.TipTitleStyle
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.attributes.ATarget
import org.jetbrains.compose.web.attributes.target
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

/**
 * The one place the product asks for anything, and it asks for nothing it needs.
 *
 * It sits right after the four figures, where somebody has just read that this costs nothing:
 * that is the honest moment to say why, and the sentence that ends it - keep it anyway - is what
 * stops the strip from reading as the price after all.
 *
 * It is a link and not a button, quiet and without the accent: the page has one action, and this
 * is not it. There is no Ko-fi widget script either - an outbound link does the same for nothing
 * and adds no third party to a page that has none.
 */
@Composable
fun LandingTip() {
    val t = LocalStrings.current

    Div(TipBandStyle.toModifier().reveal().toAttrs()) {
        Span(EyebrowStyle.toModifier().toAttrs()) { Text(t.landing.tipEyebrow) }
        P(TipTitleStyle.toModifier().toAttrs()) { Text(t.landing.tipTitle) }
        P(TipBodyStyle.toModifier().toAttrs()) { Text(t.landing.tipBody) }

        A(
            href = KOFI_URL,
            attrs = TipLinkStyle.toModifier().toAttrs {
                target(ATarget.Blank)
                attr("rel", "noopener noreferrer")
            },
        ) {
            Text(t.landing.tipCta)
        }

        P(TipAmountStyle.toModifier().toAttrs()) { Text(t.landing.tipAmount) }
    }
}
